module.exports = __webpack_public_path__ + "img/MaintenanceImage.5c1040a1.svg";